<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import * as m from "@app/paraglide/messages.js";
    /** @type {{eventIndex: any}} */
    let { event } = $props();

const tagColorMapping = {
    Character: "info",
    Location: "light",
    Organization: "warning",
    Phrase: "success",
    Other: "secondary"
}

function removeTag(tag) {
    event.tags = event.tags.filter(tg => {
        return tg.id !== tag.id;
    });

    insertHistoryAction({
        name: "remove tag", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState),
        }, ],
    });
}
</script>

<div class="col-4">
    <div class="tagWrapper">
        {#each event.tags as tag}
        <span class="badge bg-{tagColorMapping[tag.type]} {tagColorMapping[tag.type] === 'light' ? 'text-dark' : ''} m-1 text-custom-small" title={tag.definition}>
            <a href="#!/" class="text-dark" onclick={() => removeTag(tag)} aria-label={m.event_tags_remove_aria_label({term: tag.term})}><i class="bi bi-x"></i></a>
            {tag.term}
        </span>
        {:else}
        <span class="text-custom-small text-muted">{m.event_tags_no_tags()}</span>
        {/each}
    </div>
</div>

<style lang="css">
.tagWrapper {
    overflow-x: auto;
    white-space: nowrap;
}
</style>
